<template>
<div class="filetype">
    <el-dialog title="选择下载格式" :visible.sync="show">
        <div>
            <div class="dz-flex-center">
                <div :class="{'actived':type==1}" @click="type=1">PNG</div>
                <div :class="{'actived':type==2}" @click="type=2">JPEG</div>
            </div>
            <p class="tip">{{type==1?'PNG 支持透明背景':'JPEG 不支持透明背景（默认白色背景）'}}</p>
            <div class="downloadBtn" @click="download">下载图片</div>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            type: 1
        }
    },
    methods: {
        showNow() {
            this.show = true
        },
        download() {
            var type = this.type == 1 ? 'png' : 'jpeg';
            this.$emit('download', type);
            this.show = false;
            setTimeout(() => {
                this.type = 1;
            }, 500)
        }
    }

}
</script>

<style lang="scss" scoped>
.dz-flex-center {
    display: flex;
    justify-content: center;

    >div {
        width: 168px;
        line-height: 60px;
        font-size: 20px;
        text-align: center;
        border: 1px solid #ddd;
        cursor: pointer;

        &:first-child {
            margin-right: 12px
        }
    }

    .actived {
        border-color: #2771fa;
        color: #2771fa;
        position: relative;

        &:after {
            position: absolute;
            width: 24px;
            height: 24px;
            background-image: url("../assets/image/chosetype/actived.png");
            content: "";
            right: -1px;
            bottom: -1px
        }
    }
}

.tip {
    padding-left: 98px;
    font-size: 14px;
    color: #999;
    line-height: 1;
    margin: 0;
    margin-top: 16px;
}

.downloadBtn {
    width: 348px;
    color: #fff;
    background: #2771fa;
    font-size: 16px;
    margin: 0 auto;
    text-align: center;
    line-height: 52px;
    margin-top: 61px;
    cursor: pointer;
}
</style>
